<div class="app-container">
  <app-sidebar class="sidebar"></app-sidebar>

  <main class="main-content">
    <app-header class="header"></app-header>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </main>

</div>
